import React, { Fragment, useState } from "react";
import {
  useTable,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table";
import {
  TableRow,
  Button,
  Table,
  TableHead,
  TableBody,
  TableCell,
  Box,
  TextField,
  MenuItem,
  Select,
  Typography,
  IconButton,
  Icon,
  TableContainer,
  Checkbox,
} from "@mui/material";
import { Filter, DefaultColumnFilter } from "./filters";

import { ArrowBackIos, ArrowForwardIos, KeyboardArrowLeft, KeyboardArrowRight, SkipNext, SkipPrevious } from "@mui/icons-material";
import { color } from "../StyleData/Config";

const NormalTable = ({ columns, data, renderRowSubComponent,filt,handleCheckAll,checkBol,hideColumns }) => {
  const [pageIndex, setPageIndex] = useState(0);
 
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    rows,
   
    state: {  pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: { pageIndex: pageIndex, pageSize: 10, hiddenColumns: hideColumns!==undefined?hideColumns:[],},
   
    },
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  
  const handlePageChange = (newPage) => {
    setPageIndex(newPage);
    gotoPage(newPage);
  };



  return (
    <Fragment>
      <TableContainer>
        {/* <Box sx={{backgroundColor:color.TableContainerSearchBgColor,p:"3px 0",display:filt?"flex":"none",gap:'0.5rem'}}>
      {headerGroups.map((headerGroup,i) => (
        <Fragment key={i}>
        {headerGroup.headers.map((column,index) => (
          <Fragment key={index}>
        <Filter column={column} placeholder={{placeholder:column.render("Header")}} />
       
        </Fragment>
        ))}
  
        </Fragment>
      ))}
      </Box> */}
      <Table {...getTableProps()}>
        
        <TableHead>
          {headerGroups.map((headerGroup) => {
          
            return(
                       <TableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column,i) => (
                  //  console.log(column.enableHiding)
                  
                    <Fragment key={i}>
                    <TableCell
                        {...column.getHeaderProps()}
                        sx={{backgroundColor:"transparent",padding:"1rem 0.4rem",fontSize:"13px",fontWeight:700,
                        whiteSpace:"nowrap",
                        display:column.enableHiding?"none":"tableCell"
                      }}
                      >
                       
                        {column.render("Header")==="checkBox"?
                        <Checkbox checked={checkBol} onClick={handleCheckAll}/>:
                         <div {...column.getSortByToggleProps()}>
                         {column.render("Header")}
                         {generateSortingIndicator(column)}
                       </div>
                       }
                         
                        
                        {filt?<Filter column={column} />:null}  
                      
                      </TableCell>
                      
                      </Fragment>
                   )
              
          
              )}
            </TableRow>
         )
          })}
        </TableHead>

        <TableBody {...getTableBodyProps()}>
          {page.map((row) => {
            // console.log(row)
            prepareRow(row);
            return (
              <Fragment key={row.getRowProps().key}>
              <TableRow >
                    
                {row.cells.map((cell,i) => (
                    <Fragment key={i}>
                   <TableCell
                      {...cell.getCellProps()}
                      sx={{ fontSize:"12px",fontWeight:600, color:"#797979", border:"none",borderBottom:"1px solid rgba(224, 224, 224, 1)",padding:"0.5rem",display:cell.column.enableHiding?"none":"tableCell"}}
                    >
                 
                      {cell.render("Cell")}
                    </TableCell>
                   
                    </Fragment>
                  )
                )}
              </TableRow>
               {row.isExpanded ? (
                <TableRow>
                  <TableCell sx={{padding:0}} colSpan={row.cells.length} >
                    {/*
                        Inside it, call our renderRowSubComponent function. In reality,
                        you could pass whatever you want as props to
                        a component like this, including the entire
                        table instance. But for this example, we'll just
                        pass the row
                      */}
                    {renderRowSubComponent({ row })}
                  </TableCell>
                </TableRow>
              ) : null}
              </Fragment>
            );
          })}
        </TableBody>
      </Table>
      {/* <Box sx={{
        backgroundColor:color.TableBgColor,
       
        }}>
  
        <Box sx={{display:"flex",gap:{xs:"5px",md:"1rem"},justifyContent:"flex-end",alignItems:"center",p:"0.4rem",whiteSpace:"break-spaces"}}>
       
        <Box sx={{display:"flex",alignItems:"center",gap:"0.5rem"}}>
            
         
        </Box>
        <Box>
          <Typography>{pageIndex+1+" of "+pageOptions.length}</Typography>
        </Box>
        <Box sx={{display:"flex"}}>
          <IconButton  onClick={() => handlePageChange(0)}
            disabled={!canPreviousPage}>
          <SkipPrevious
           sx={{color:!canPreviousPage?"gray":"blue",fontSize:'1.5rem'}}
           
         />
         
         </IconButton> 
         <IconButton  onClick={()=>handlePageChange(pageIndex - 1)}
            disabled={!canPreviousPage}>
          <KeyboardArrowLeft
            sx={{color:!canPreviousPage?"gray":"blue",fontSize:"1.5rem"}}
           
          />
         
         </IconButton>
      
       
         <Select
            variant='standard'
            value={pageSize}
            onChange={onChangeInSelect}
          >
            
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <MenuItem key={pageSize} value={pageSize}>
              {pageSize}
              </MenuItem>
            ))}
          </Select>
        
          <IconButton  onClick={()=>handlePageChange(pageIndex + 1)} disabled={!canNextPage}>
          <KeyboardArrowRight  sx={{color:!canNextPage?"gray":"blue",fontSize:"1.5rem"}} />
          </IconButton>
          <IconButton  onClick={() => handlePageChange(pageCount - 1)}
            disabled={!canNextPage}>
          <SkipNext
           sx={{color:!canNextPage?"gray":"blue",fontSize:"1.5rem"}}
           
          />
          </IconButton>
        </Box>
        </Box>
      
      </Box> */}
      <Box
            sx={{
              backgroundColor: color.TableBgColor,
              // boxShadow:"0px 5px 10px #00000033",
              // border:"0.5px solid rgb(187 187 187 / 31%)",
              // borderRadius:"2px"
            }}
          >
            {/* <Box sx={{display:"flex",gap:{xs:"5px",md:"2rem"},justifyContent:"flex-end",alignItems:"center",p:"0.4rem",whiteSpace:"nowrap"}}> */}
            <Box
              sx={{
                display: "flex",
                gap: { xs: "5px", md: "2rem" },
                justifyContent: "flex-end",
                alignItems: "center",
                p: "0.4rem",
                whiteSpace: "nowrap",
              }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <Typography sx={{ display: { xs: "none", md: "block" } }}>
                  Rows:
                </Typography>
                <Select
                  variant="standard"
                  value={pageSize}
                  onChange={onChangeInSelect}
                >
                  {[10, 20, 30, 40, 50].map((pageSize) => (
                    <MenuItem key={pageSize} value={pageSize}>
                      {pageSize}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Box>
                <Typography>
                  {pageIndex + 1 + " of " + pageOptions.length}
                </Typography>
              </Box>
              <Box sx={{ display: "flex" }}>
                <IconButton
                  onClick={() => handlePageChange(0)}
                  disabled={!canPreviousPage}
                >
                  <SkipPrevious
                    sx={{
                      color: !canPreviousPage ? "gray" : "blue",
                      fontSize: "1.5rem",
                    }}
                  />
                </IconButton>
                <IconButton onClick={()=>handlePageChange(pageIndex - 1)} disabled={!canPreviousPage}>
                  <KeyboardArrowLeft
                    sx={{
                      color: !canPreviousPage ? "gray" : "blue",
                      fontSize: "1.5rem",
                    }}
                  />
                </IconButton>

                <IconButton onClick={()=>handlePageChange(pageIndex + 1)} disabled={!canNextPage}>
                  <KeyboardArrowRight
                    sx={{
                      color: !canNextPage ? "gray" : "blue",
                      fontSize: "1.5rem",
                    }}
                  />
                </IconButton>
                <IconButton
                  onClick={() => handlePageChange(pageCount - 1)}
                  disabled={!canNextPage}
                >
                  <SkipNext
                    sx={{
                      color: !canNextPage ? "gray" : "blue",
                      fontSize: "1.5rem",
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box>
     
      </TableContainer>
    </Fragment>
  );
};

export default NormalTable;
